import { FormattedMessage } from 'react-intl';
import { memo } from 'react';
import { VStack } from '../../layout';
import { Paragraph } from '../../typography';
import Filters from './Filters';
import type { CommonFiltrationProps } from './types';
import FiltersValues from './FiltersValues';

const Filtration = <T,>({
    filters,
    filterValue,
    emptyValue,
    onChangeFilters,
    total,
}: CommonFiltrationProps<T>) => {
    return (
        <VStack gap="small">
            <Filters
                filters={filters}
                filterValue={filterValue}
                onChangeFilters={onChangeFilters}
            />
            {total !== undefined && (
                <Paragraph>
                    <FormattedMessage
                        id="Library Filtration Results"
                        values={{ resultsCount: total }}
                    />
                </Paragraph>
            )}

            <FiltersValues
                filters={filters}
                filterValue={filterValue}
                onChangeFilters={onChangeFilters}
                emptyValue={emptyValue}
            />
        </VStack>
    );
};

// eslint-disable-next-line @hostettler/memoize-component
export default memo(Filtration) as unknown as typeof Filtration;
